import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $isGrabbable: boolean;
  $isGrabbed: boolean;
}>`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(1.5)}`};
  width: 100%;
  min-width: 0;

  cursor: ${({ $isGrabbed }) => ($isGrabbed ? 'grabbing' : 'default')};

  color: ${({ theme }) => theme.palette.grey[400]};

  ${({ theme, $isGrabbable }) =>
    $isGrabbable &&
    css`
      &:hover {
        background: ${theme.palette.grey[100]};
      }
    `};
`;

export const Content = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};

  min-width: 0;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const IllustrationContainer = styled.span`
  position: relative;
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  min-height: 2rem;

  border-radius: ${({ theme }) => theme.spacing(1.5)};

  color: ${({ theme }) => theme.palette.grey[400]};
  font-size: 1.2rem;
  line-height: 62.5%;
`;

export const IconContainer = styled.span`
  display: block;
  padding: ${({ theme }) => theme.spacing(1)};

  line-height: 62.5%;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MetaContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const DeadlineContainer = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: inline-block;
  padding: ${({ theme }) => `0 ${theme.spacing(1)}`};

  border-radius: ${({ theme }) => theme.spacing(1)};
  background: ${({ theme }) => theme.palette.grey[50]};
`;
